import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const studentId = localStorage.getItem('xh');
    
    if (!studentId) {
        return <Navigate to="/login" replace />;
    }
    
    return children;
};

export default PrivateRoute; 